import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { PagamentosService } from '@app/shared/components/api/services/pagamentos.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';
import { TableModule } from 'primeng/table';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { ConfiguracoesService } from '@app/shared/components/api/services/configuracoes.service';
import { DocumentoService } from '@app/shared/components/api/services/documento.service';
import { MessageService } from 'primeng/api';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'app-detalhe-pagamento',
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    MoneyPipe,
    TableModule,
    ProgressSpinner,
  ],
  standalone: true,
  providers: [
    PagamentosService,
    ApoioService,
    ConfiguracoesService,
    DocumentoService,
  ],
  templateUrl: './detalhe-pagamento.component.html',
  styleUrl: './detalhe-pagamento.component.scss',
})
export class DetalhePagamentoComponent implements OnInit {
  private readonly configuracoesService = inject(ConfiguracoesService);
  private readonly apoioService = inject(ApoioService);
  private readonly documentoService = inject(DocumentoService);
  private readonly messageService = inject(MessageService);
  @Input() pagamentoID: any;
  @Output() onCloseModal = new EventEmitter<boolean>();
  pagamento: any;
  taxaServico: number = 0;
  ValorTaxa: number = 0;
  tipoFinanciamento: number = 1;
  loading: boolean = false;

  ngOnInit(): void {
    if (this.pagamentoID) {
      this.apoioService.show(this.pagamentoID).subscribe({
        next: (res) => {
          this.pagamento = res.data;
          this.tipoFinanciamento =
            this.pagamento?.campanha?.tipoFinanciamentoENUM || 1;

          if (
            this.pagamento?.taxaServico !== undefined &&
            this.pagamento?.taxaServico !== null
          ) {
            this.taxaServico = this.pagamento.taxaServico;
          } else {
            this.getTaxaServico();
          }

          if (
            this.pagamento?.valorTaxa !== undefined &&
            this.pagamento?.valorTaxa !== null
          ) {
            this.ValorTaxa = this.pagamento.valorTaxa;
          }
        },
        error: (error) => {
          console.error('Erro ao carregar pagamento:', error);
        },
      });
    } else {
      this.getTaxaServico();
    }
  }

  getTaxaServico() {
    this.configuracoesService.getTaxaServico(this.tipoFinanciamento).subscribe({
      next: (value: any) => {
        if (value !== undefined && value !== null) {
          this.taxaServico = Number(value) || 0;
        }
      },
      error: () => {
        this.taxaServico = 0;
      },
    });
  }

  closeDetalhe() {
    this.onCloseModal.emit(true);
  }

  exportarComprovativoDoacaoFundo(pagamento: any) {
    this.loading = true;
    const id = pagamento?.campanha?.id;
    this.documentoService.exportComprovativoDoacaoFundo(id).subscribe({
      next: (res: any) => {
        // Download do arquivo
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Comprovativo_Doacao_${id || 'campanha'}.pdf`;
        this.loading = false;
        a.click();
        globalThis.URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Comprovativo de Doação exportado com sucesso!',
          life: 5000,
        });
      },

      error: (err: Error) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao exportar o comprovativo de Doação',
          life: 5000,
        });
        this.loading = false;
      },
    });
  }
}
